<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-user-alt"></i> Point of Contact</h4>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="pointofcontact">
      <div class="row">
        <div class="col-12 p-3">
          <p class="sub-title">HI Details</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Name of the Head of HI </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Name of the Head of HI"
                formControlName="hiName"
                maxlength="70"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Designation of the Head of HI</mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Designation of the Head of HI"
                formControlName="hiDesignation"
                maxlength="45"
                (keydown.enter)="preventEnterKey($event)"
                oninput="this.value = this.value.replace(/[^a-zA-Z ]/g,'')"
              />
              <mat-error
                *ngIf="
                  setting.hiDesignation.touched && setting.hiDesignation.errors
                "
              >
                <span *ngIf="setting.hiDesignation.errors.required"
                  >Please Enter Designation of the Head of HI</span
                >
                <span *ngIf="setting.hiDesignation?.errors?.pattern">
                  Whitespace not allowed
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Mobile no. of HI Head </mat-label>
              <input
                matInput
                placeholder="Enter Mobile no. of HI Head"
                type="text"
                readonly="{{ showForm }}"
                formControlName="hiMobile"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="10"
                minlength="10"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>E-mail of HI Head </mat-label>
              <input
                matInput
                formControlName="hiEmail"
                placeholder="Enter E-mail of HI Head"
                readonly="{{ showForm }}"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                type="text"
                (keydown.space)="$event.preventDefault()"
              />
              <mat-error>
                <span *ngIf="setting.hiEmail.errors?.pattern">
                  <i class="fas fa-exclamation-triangle"></i>
                  Please Enter Valid E-Mail
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-12 p-3">
          <p class="sub-title">CoE Details</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Name of the Co-ordinator of CoE </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Name of the Co-ordinator of CoE"
                formControlName="coeName"
                maxlength="70"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Mobile no. of CoE Co-ordinator </mat-label>
              <input
                matInput
                placeholder="Enter Mobile no. of CoE Co-ordinator"
                type="text"
                readonly="{{ showForm }}"
                formControlName="coeMobile"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="10"
                minlength="10"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>E-mail of CoE Co-ordinator </mat-label>
              <input
                matInput
                formControlName="coeEmail"
                placeholder="Enter E-mail of CoE Co-ordinator"
                readonly="{{ showForm }}"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                type="text"
                (keydown.space)="$event.preventDefault()"
              />
              <mat-error>
                <span *ngIf="setting.coeEmail.errors?.pattern">
                  <i class="fas fa-exclamation-triangle"></i>
                  Please Enter Valid E-Mail
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Continue
        </button>
      </div>
    </form>
  </div>
</section>
